export const userAttributeLabels = {
  firstName: {
    id: 'MyAccount.Details.Edit.GivenName',
    defaultMessage: '** Given name',
  },
  middleName: {
    id: 'MyAccount.Details.Edit.MiddleName',
    defaultMessage: '** Middle name',
  },
  lastName: {
    id: 'MyAccount.Details.Edit.FamilyName',
    defaultMessage: '** Family name',
  },
  title: {
    id: 'MyAccount.Details.Edit.UserTitle',
    defaultMessage: '** Title',
  },
  gender: {
    id: 'MyAccount.Details.Edit.Gender',
    defaultMessage: '** Gender',
  },
  dateOfBirth: {
    id: 'MyAccount.Details.Edit.DateOfBirth',
    defaultMessage: '** Date of Birth',
  },
  email: {
    id: 'MyAccount.Details.Edit.Email',
    defaultMessage: '** Email address',
  },
  phoneNumber: {
    id: 'MyAccount.Details.Edit.MobilePhoneNumber',
    defaultMessage: '** Mobile phone number',
  },
  address: {
    id: 'MyAccount.Details.Edit.Address',
    defaultMessage: '** Address',
  },
  description: {
    id: 'MyAccount.Details.Edit.Profile',
    defaultMessage: '** Profile',
  },
};
